'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

BucketedIncidentGraphDirective=function(_BaseControllerBacked){_inherits(BucketedIncidentGraphDirective,_BaseControllerBacked);function BucketedIncidentGraphDirective(){_classCallCheck(this,BucketedIncidentGraphDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(BucketedIncidentGraphDirective,[{key:'controller',get:function()
{return BucketedIncidentGraphDirectiveController}},{key:'objectBindings',get:function()
{return['group','interval','incidents','bucketType','selectedNotificationType']}},{key:'templateUrl',get:function()
{
return'/templates/features/fleetInsight/components/fleetIncidents/bucketedIncidentGraphTemplate';
}}]);return BucketedIncidentGraphDirective}(BaseControllerBackedDirective);


const MinimumPointRadius=2;
const MaximumPointRadius=5;
const MinimumPaddingBetweenColumns=1;

const MaximumFatiguePointValue=25;
const MinimumAggregateCeiling=10;

const TransitionDuration=400;
const MaxNumIncidentsForAnimations=1600;

const GroupsAndTrendsSectionWidth=0;
const AdditionalVerticalSpaceForOptionSelectors=40*3;
const VerticalSpaceForAggregateStatistics=25;
const AggregateBucketAreaHeight=83;



const xAxisMajorTickVerticalOffset=12;
const xAxisMajorTickHorizontalOffset=0;

const MinimumPointAreaHeight=276;
const MinimumGraphAreaWidth=492;

const BucketSizeIndexByType={
NotApplicable:0,
Below:1,
At:2,
Above:3};let


BucketedIncidentGraphDirectiveController=function(){
function BucketedIncidentGraphDirectiveController($scope,$timeout,elementService,timeZoneService){var _this2=this;_classCallCheck(this,BucketedIncidentGraphDirectiveController);
this._$scope=$scope;
this._$timeout=$timeout;
this._elementService=elementService;
this._localTimeZone=timeZoneService.localTimeZone;
this._svgContainer=null;
this.tooltipVisible=!1;

this._isInternetExplorer=!!document.querySelector('html.browser-explorer');

const _debouncedRedraw=_.debounce(function(options){return $timeout(function(){return _this2._redraw(options)})},10);
const _redrawIfNew=function(newVal,oldVal){
if(!_.exists(newVal)||
newVal===oldVal||
newVal.some(function(v){return!_.exists(v)})||
newVal.every(function(v,i){return v===oldVal[i]})){
return;
}

_debouncedRedraw();
};

$scope.$on('resize::resize',function(){return _debouncedRedraw({preventAnimation:!0,isResizing:!0})});
$scope.$watch('controller.selectedNotificationType',function(){return _debouncedRedraw({preventAnimation:!0})});

$scope.$watchGroup([
'controller.incidents',
'controller.bucketType'],
_redrawIfNew);
}BucketedIncidentGraphDirectiveController.prototype.

_getCurrentDrawToken=function _getCurrentDrawToken(){
const numIncidents=this.incidents.length;
return[
this.interval.start.toISOString(),
this.interval.end.toISOString(),
this.selectedNotificationType.name,
this.bucketType.label,
this.moduleElement.clientWidth,
this.moduleElement.clientHeight,
numIncidents>0?this.incidents[numIncidents-1].id:null,
numIncidents>0?this.incidents[0].id:null,
numIncidents].
join('|');
};BucketedIncidentGraphDirectiveController.prototype.

_redraw=function _redraw(){let{preventAnimation=!1,isResizing=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
if(!_.allExist(this.moduleElement,this.selectedNotificationType,this.bucketType)){
return;
}

const currentDrawToken=this._getCurrentDrawToken();
if(this._lastDrawToken===currentDrawToken){
return;
}
this._lastDrawToken=currentDrawToken;

if(!_.exists(this.graphAreaWidth)||isResizing){
this._updateDimensions(this.moduleElement.clientWidth,this.moduleElement.clientHeight);
}

this.tooltipVisible=!1;

const{buckets:buckets,bucketIndexMap:bucketIndexMap,bucketSizes:bucketSizes}=this.bucketType.getAllBucketsWithInitialViewData(this.interval,this._localTimeZone);
const shouldAnimateTransition=!preventAnimation&&!this._isInternetExplorer&&this.incidents.length<MaxNumIncidentsForAnimations;

this._setupGraphs(buckets,shouldAnimateTransition);

this._setupPointViewData(buckets,bucketIndexMap,bucketSizes);
this._setupAllPoints(shouldAnimateTransition);
this._setupAggregateBars(buckets,shouldAnimateTransition);

let pointRadius=MaximumPointRadius;
if(buckets.length>1){
const spaceBetweenRows=Math.abs(this._pointAreaYScale(1)-this._pointAreaYScale(0));
const spaceBetweenColumns=Math.abs(this._xScale(buckets[1])-this._xScale(buckets[0]));
const proposedPointRadius=Math.min(spaceBetweenColumns,spaceBetweenRows)/2-MinimumPaddingBetweenColumns;
pointRadius=_.clamp(proposedPointRadius,MinimumPointRadius,MaximumPointRadius);
}

this._updateAllPoints(buckets,shouldAnimateTransition,pointRadius);
this._updateAggregates(buckets,shouldAnimateTransition,pointRadius);
this._updateXAxis(buckets,shouldAnimateTransition);

this._shouldAnimateLastPoints=shouldAnimateTransition;
};BucketedIncidentGraphDirectiveController.prototype.

captureMouseTarget=function captureMouseTarget($event){
this._lastMouseTarget=$event.target;
};BucketedIncidentGraphDirectiveController.prototype.

_setupPointViewData=function _setupPointViewData(buckets,bucketIndexMap,bucketSizes){
const incidentsByThresholdStatus={
Above:[],
At:[],
Below:[],
NotApplicable:[]};


const numIncidents=this.incidents.length;
const incidentCoordinates=Array(numIncidents);
for(let i=0;i<numIncidents;i++){
const bucket=this.bucketType.getBucketFor(this.incidents[i]);
const thresholdStatus=this.incidents[i].thresholdStatusFor(this.selectedNotificationType);

incidentsByThresholdStatus[thresholdStatus.value].push(this.incidents[i]);
bucketSizes[bucketIndexMap.get(bucket)][BucketSizeIndexByType[thresholdStatus.value]]++;
incidentCoordinates[i]=[this.incidents[i],[this._xScale(bucket),this._pointAreaYScale(this.incidents[i].fatigue)]];
}

this._bucketSizes=bucketSizes;
this._incidentsByThresholdStatus=incidentsByThresholdStatus;
this._incidentCoordinateMap=new Map(incidentCoordinates);
};BucketedIncidentGraphDirectiveController.prototype.

_updateDimensions=function _updateDimensions(moduleWidth,moduleHeight){
this.axisLabelMargins={
top:MaximumPointRadius+MinimumPaddingBetweenColumns,
right:0,
bottom:25,
left:34};


this.graphAreaPadding={
top:0,
right:(MaximumPointRadius+MinimumPaddingBetweenColumns)*2,
bottom:0,
left:(MaximumPointRadius+MinimumPaddingBetweenColumns)*2};


this.graphAreaWidth=Math.floor(Math.max(MinimumGraphAreaWidth,moduleWidth-
GroupsAndTrendsSectionWidth-
this.axisLabelMargins.left-
this.axisLabelMargins.right));

this.aggregateBucketDimensions={
height:AggregateBucketAreaHeight,
width:this.graphAreaWidth};


const availableHeightForPointArea=moduleHeight-
AdditionalVerticalSpaceForOptionSelectors-
VerticalSpaceForAggregateStatistics-
AggregateBucketAreaHeight-
this.axisLabelMargins.top-
this.axisLabelMargins.bottom;

this.pointAreaDimensions={
height:Math.floor(Math.max(MinimumPointAreaHeight,availableHeightForPointArea)),
width:this.graphAreaWidth};


this.graphAreaWithLabelsDimensions={
height:this.aggregateBucketDimensions.height+
this.pointAreaDimensions.height+
this.axisLabelMargins.top+
this.axisLabelMargins.bottom,

width:this.graphAreaWidth+
this.axisLabelMargins.left+
this.axisLabelMargins.right};

};BucketedIncidentGraphDirectiveController.prototype.

_setupGraphs=function _setupGraphs(buckets,shouldAnimateTransition){
if(!_.exists(this._svgContainer)){
this._svgContainer=d3.select('#incident-graph');

this._pointAreaBackground=this._svgContainer.append('rect').
attr({class:'background',transform:`translate(${this.axisLabelMargins.left},${this.axisLabelMargins.top})`});

this._xAxis=this._svgContainer.append('g').
attr({class:'x axis'});

this._xAxisMajor=this._svgContainer.append('g').
attr({class:'x axis major'});

this._pointAreaYScale=d3.scale.linear().
clamp(!0).
domain([0,MaximumFatiguePointValue]);

this._pointAreaYAxis=this._svgContainer.append('g').
attr({class:'y axis points'});

this._pointGroupAll=this._svgContainer.append('g').
attr('transform',`translate(${this.axisLabelMargins.left},${this.axisLabelMargins.top})`);
this._pointGroupBelow=this._pointGroupAll.
append('g').
attr({class:'points below-threshold'});
this._pointGroupAt=this._pointGroupAll.
append('g').
attr({class:'points at-threshold'});
this._pointGroupAbove=this._pointGroupAll.
append('g').
attr({class:'points above-threshold'});

this._aggregateGroup=this._svgContainer.append('g').
attr({class:'aggregates'});

this._aggregateBucketYAxis=this._svgContainer.append('g').
attr({class:'y axis aggregate'});

this._yAxisUnitLabels=this._svgContainer.append('g').
attr({class:'y axis unit-label'});

this._pointAreaYUnitsLabel=this._yAxisUnitLabels.append('text').text('Fatigue During Event');
this._aggregateYUnitsLabel=this._yAxisUnitLabels.append('text').text('Total');
}

this._svgContainer.
attr(this.graphAreaWithLabelsDimensions).
style('width',`${this.graphAreaWithLabelsDimensions.width}px`).
style('height',`${this.graphAreaWithLabelsDimensions.height}px`);

this._xAxisRange=[this.graphAreaPadding.left,this.pointAreaDimensions.width-this.graphAreaPadding.right];
this._xScale=d3.scale.ordinal().domain(buckets).rangePoints(this._xAxisRange);

this._pointAreaYScale.
rangeRound([this.pointAreaDimensions.height-this.graphAreaPadding.bottom,this.graphAreaPadding.top]);

const pointYAxis=d3.svg.axis().
scale(this._pointAreaYScale).
orient('left').
ticks(5).
tickSize(this.pointAreaDimensions.width);
this._pointAreaYAxis.call(pointYAxis);
this._pointAreaBackground.attr(this.pointAreaDimensions);

this._pointAreaYUnitsLabel.attr({
x:this.aggregateBucketDimensions.height+0.5*this.pointAreaDimensions.height,
y:0});

this._aggregateYUnitsLabel.attr({
x:0.5*this.aggregateBucketDimensions.height,
y:0});


this._shiftLayersToCorrectPosition();
};BucketedIncidentGraphDirectiveController.prototype.

_shiftLayersToCorrectPosition=function _shiftLayersToCorrectPosition(){
const xAxisVerticalOffset=this.graphAreaWithLabelsDimensions.height-this.axisLabelMargins.top-this.axisLabelMargins.bottom;
this._xAxis.
attr({transform:`translate(${this.axisLabelMargins.left},${xAxisVerticalOffset})`});
this._xAxisMajor.
attr({transform:`translate(${this.axisLabelMargins.left+xAxisMajorTickHorizontalOffset},${xAxisVerticalOffset+xAxisMajorTickVerticalOffset})`});

this._pointAreaYAxis.
attr({transform:`translate(${this.pointAreaDimensions.width+this.axisLabelMargins.left},${this.axisLabelMargins.top})`});

this._aggregateBucketYAxis.
attr({transform:`translate(${this.pointAreaDimensions.width+this.axisLabelMargins.left},${this.axisLabelMargins.top+this.pointAreaDimensions.height})`});

this._aggregateGroup.
attr({transform:`translate(${this.axisLabelMargins.left},${this.pointAreaDimensions.height+this.axisLabelMargins.top})`});

this._yAxisUnitLabels.
attr({transform:`translate(10,${xAxisVerticalOffset+xAxisMajorTickVerticalOffset}),rotate(-90)`});
};BucketedIncidentGraphDirectiveController.prototype.

_setupAllPoints=function _setupAllPoints(shouldAnimateTransition){
this._pointsBelow=this._setupPoints(
this._pointGroupBelow,
this._incidentsByThresholdStatus.Below.concat(this._incidentsByThresholdStatus.NotApplicable),
shouldAnimateTransition);

this._pointsAt=this._setupPoints(
this._pointGroupAt,
this._incidentsByThresholdStatus.At,
shouldAnimateTransition);

this._pointsAbove=this._setupPoints(
this._pointGroupAbove,
this._incidentsByThresholdStatus.Above,
shouldAnimateTransition);
};BucketedIncidentGraphDirectiveController.prototype.

_setupPoints=function _setupPoints(pointGroup,incidents,shouldAnimateTransition){
const points=pointGroup.
selectAll('circle').
data(incidents,function(i){return i.id});

const self=this;
const enteringPoints=points.enter().append('circle');
if(shouldAnimateTransition){
enteringPoints.
attr({r:0});
}

enteringPoints.
on('mouseover',function(d,i,a){
angular.element(this).addClass('hovered');

self._showTooltip(d,this);
}).
on('mouseout',function(d,i,a){
angular.element(this).removeClass('hovered');

self._hideTooltip(d,this);
}).
on('click',function(d,i,a){
d.viewSchedule();
});

const exitingPoints=points.exit();
if(this._shouldAnimateLastPoints&&shouldAnimateTransition){
exitingPoints.
transition().duration(TransitionDuration).
attr({r:0}).
each('end',_removeElement);
}else{
exitingPoints.
remove();
}

return points;
};BucketedIncidentGraphDirectiveController.prototype.

_setupAggregateBars=function _setupAggregateBars(buckets,shouldAnimateTransition){
const aggregateDomain=[0,Math.max.apply(Math,[MinimumAggregateCeiling].concat(_toConsumableArray(this._bucketSizes.map(_.sum))))];
this._aggregateBucketYScale=d3.scale.linear().
domain(aggregateDomain).
rangeRound([0,this.aggregateBucketDimensions.height]);

const aggregateYAxis=d3.svg.axis().
scale(this._aggregateBucketYScale.copy().rangeRound([this.aggregateBucketDimensions.height,0])).
orient('left').
tickValues(aggregateDomain).
tickSize(this.pointAreaDimensions.width);
this._aggregateBucketYAxis.call(aggregateYAxis);

const numBuckets=buckets.length;
const bucketHeight=this.aggregateBucketDimensions.height;
const countsByBucketInfo=Array(numBuckets);
for(let index=0;index<numBuckets;index++){
const x=this._xScale(buckets[index]);
const heightBelow=this._aggregateBucketYScale(this._bucketSizes[index][BucketSizeIndexByType.Below]+
this._bucketSizes[index][BucketSizeIndexByType.NotApplicable]);
const heightAt=this._aggregateBucketYScale(this._bucketSizes[index][BucketSizeIndexByType.At]);
const heightAbove=this._aggregateBucketYScale(this._bucketSizes[index][BucketSizeIndexByType.Above]);

countsByBucketInfo[index]=[{
x:x,
height:heightAbove,
y:bucketHeight-heightAbove,
class:'above-threshold',
id:`${buckets[index]}_0`},
{
x:x,
height:heightAt,
y:bucketHeight-(heightAt+heightAbove),
class:'at-threshold',
id:`${buckets[index]}_1`},
{
x:x,
height:heightBelow,
y:bucketHeight-(heightBelow+heightAt+heightAbove),
id:`${buckets[index]}_2`}];

}

this._aggregateBars=this._aggregateGroup.
selectAll('rect').
data(_.flatten(countsByBucketInfo),function(d){return d.id});

if(shouldAnimateTransition){
this._aggregateBars.
enter().
append('rect').
attr({
y:this.aggregateBucketDimensions.height,
height:0});

}else{
this._aggregateBars.
enter().
append('rect');
}

if(this._shouldAnimateLastPoints&&shouldAnimateTransition){
this._aggregateBars.
exit().
transition().duration(TransitionDuration).
attr({y:this.aggregateBucketDimensions.height,height:0}).
each('end',_removeElement);
}else{
this._aggregateBars.
exit().
remove();
}
};BucketedIncidentGraphDirectiveController.prototype.

_showTooltip=function _showTooltip(incident,targetElement){var _this3=this;
this._$timeout(function(){
if(_this3._lastMouseTarget!==targetElement){


return;
}

const effectiveDeviationThreshold=incident.thresholdFor(NotificationType.DeviationThresholdExceeded);

_this3.tooltipData={
incident:incident,
fatigueThresholdStatus:incident.thresholdStatusFor(NotificationType.FatigueThresholdExceeded),
deviationThresholdStatus:ThresholdStatus.fromScoreAndThreshold(incident.fatigue,effectiveDeviationThreshold),
deviation:ThresholdStatus.getDeviationFromEffectiveThreshold(incident.fatigue,effectiveDeviationThreshold),
fatigue:incident.fatigue,
time:incident.time,
description:incident.description,
timezone:incident.timezone,
person:_.find(_this3.group.aggregatePersons,function(p){return p.incidents.includes(incident)}),
targetElement:targetElement};


_this3.tooltipVisible=!0;
},100);
};BucketedIncidentGraphDirectiveController.prototype.

_hideTooltip=function _hideTooltip(incident){var _this4=this;
this._$timeout(function(){
_this4.tooltipVisible=!1;
});
};BucketedIncidentGraphDirectiveController.prototype.

_updateAllPoints=function _updateAllPoints(buckets,shouldAnimateTransition,pointRadius){
this._updatePoints(this._pointsBelow,shouldAnimateTransition,pointRadius);
this._updatePoints(this._pointsAt,shouldAnimateTransition,pointRadius);
this._updatePoints(this._pointsAbove,shouldAnimateTransition,pointRadius);
};BucketedIncidentGraphDirectiveController.prototype.

_updatePoints=function _updatePoints(points,shouldAnimateTransition,pointRadius){var _this5=this;
const pointsWithOrWithoutTransition=shouldAnimateTransition?
points.transition().duration(TransitionDuration):
points;

pointsWithOrWithoutTransition.
attr({
r:pointRadius,
cx:function(d,i){return _this5._incidentCoordinateMap.get(d)[0]},
cy:function(d,i){return _this5._incidentCoordinateMap.get(d)[1]}});

};BucketedIncidentGraphDirectiveController.prototype.

_updateAggregates=function _updateAggregates(buckets,shouldAnimateTransition,pointRadius){
const aggregateBarsWithOrWithoutTransition=shouldAnimateTransition?
this._aggregateBars.transition().duration(TransitionDuration):
this._aggregateBars;

const roundedRadius=Math.round(pointRadius);

aggregateBarsWithOrWithoutTransition.
attr({
width:roundedRadius*2,
height:function(b){return b.height},
y:function(b){return b.y},
x:function(b){return b.x-roundedRadius},
class:function(b){return b.class}});

};BucketedIncidentGraphDirectiveController.prototype.

_updateXAxis=function _updateXAxis(buckets,shouldAnimateTransition){
const xAxisWithOrWithoutTransition=shouldAnimateTransition?
this._xAxis.transition().duration(TransitionDuration):
this._xAxis;

const xScale=d3.time.scale().
domain(this.bucketType.getDomain(this.interval)).
range(this._xAxisRange);

const tickInfo=this.bucketType.getTickInfo(this.interval,this._xAxisRange[1]-this._xAxisRange[0]);
const formatterForTickInfo=function(tickInfo){return typeof tickInfo.format=='string'?d3.time.format(tickInfo.format):tickInfo.format};

const pointXAxis=d3.svg.axis().
scale(xScale).
orient('bottom').
ticks(tickInfo.minor.ticks,tickInfo.minor.step).
tickFormat(formatterForTickInfo(tickInfo.minor));

xAxisWithOrWithoutTransition.call(pointXAxis);

if(_.exists(tickInfo.major)){
const xAxisMajorTicks=d3.svg.axis().
scale(xScale).
orient('bottom').
ticks(tickInfo.major.ticks,tickInfo.major.step).
tickFormat(formatterForTickInfo(tickInfo.major));

this._xAxisMajor.
attr('class','x axis major').
call(xAxisMajorTicks);
}else{
this._xAxisMajor.attr('class','x axis major hidden');
}
};_createClass(BucketedIncidentGraphDirectiveController,[{key:'moduleElement',get:function()

{
return this._moduleElement||(this._moduleElement=this._elementService.selectElement('.fleet-module')[0]);
}}]);return BucketedIncidentGraphDirectiveController}();


function _removeElement(){
if(typeof this.remove=='function'){
return this.remove();
}

if(_.exists(this.parentNode)){
return this.parentNode.removeChild(this);
}


}

module.exports=BucketedIncidentGraphDirective;
//# sourceMappingURL=bucketedIncidentGraphDirective.js.map
